(function () {
  'use strict';

  function cleanProductUrl() {
    return window.location.origin + window.location.pathname;
  }

  function copyText(value) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(value);
    }

    return new Promise(function (resolve, reject) {
      try {
        var textarea = document.createElement('textarea');
        textarea.value = value;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        var ok = document.execCommand('copy');
        document.body.removeChild(textarea);
        if (ok) resolve();
        else reject(new Error('copy failed'));
      } catch (error) {
        reject(error);
      }
    });
  }

  function init(root) {
    if (!root || root.dataset.kShareReady === 'true') return;
    root.dataset.kShareReady = 'true';

    var trigger = root.querySelector('[data-k-share-trigger]');
    var menu = root.querySelector('[data-k-share-menu]');
    var whatsapp = root.querySelector('[data-k-share-whatsapp]');
    var copyLink = root.querySelector('[data-k-copy-link]');
    var copyOem = root.querySelector('[data-k-copy-oem]');
    var status = root.querySelector('[data-k-share-status]');
    var title = root.getAttribute('data-k-share-title') || document.title;
    var oem = root.getAttribute('data-k-share-oem') || '';
    var cleanUrl = cleanProductUrl();
    var message = title + (oem ? '\nRéf. du fabricant : ' + oem : '') + '\n' + cleanUrl;
    var statusTimer = null;

    function announce(text) {
      if (!status) return;
      window.clearTimeout(statusTimer);
      status.textContent = text;
      statusTimer = window.setTimeout(function () {
        status.textContent = '';
      }, 2200);
    }

    function closeMenu(restoreFocus) {
      if (!menu || menu.hidden) return;
      menu.hidden = true;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (restoreFocus && trigger) trigger.focus();
    }

    function openMenu() {
      if (!menu || !trigger) return;
      menu.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      var first = menu.querySelector('a,button');
      if (first) window.setTimeout(function () { first.focus(); }, 0);
    }

    if (whatsapp) {
      whatsapp.href = 'https://wa.me/?text=' + encodeURIComponent(message);
      whatsapp.addEventListener('click', function () {
        closeMenu(false);
      });
    }

    if (copyLink) {
      copyLink.addEventListener('click', function () {
        copyText(cleanUrl).then(function () {
          announce('Lien copié');
          closeMenu(false);
        }).catch(function () {
          announce('Impossible de copier le lien');
        });
      });
    }

    if (copyOem && oem) {
      copyOem.addEventListener('click', function () {
        copyText(oem).then(function () {
          announce('Référence copiée');
          closeMenu(false);
        }).catch(function () {
          announce('Impossible de copier la référence');
        });
      });
    }

    if (trigger) {
      trigger.addEventListener('click', function () {
        if (!menu.hidden) {
          closeMenu(false);
          return;
        }

        if (navigator.share) {
          navigator.share({
            title: title,
            text: oem ? 'Réf. du fabricant : ' + oem : title,
            url: cleanUrl
          }).catch(function (error) {
            if (error && error.name === 'AbortError') return;
            openMenu();
          });
          return;
        }

        openMenu();
      });
    }

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) closeMenu(false);
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeMenu(true);
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-k-product-share]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
